import { render, staticRenderFns } from "./StudyRequestSideBar.vue?vue&type=template&id=56affda9&"
import script from "./StudyRequestSideBar.vue?vue&type=script&lang=js&"
export * from "./StudyRequestSideBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports